import actions from './actions';
import {registerMiddleware} from '@homeaway/redux-middleware-adapter';
import {writeToStorage} from '../../utils/local-storage';

export const STARTED_KEY = 'tripboards.onboardingstarted';
export const COMPLETED_KEY = 'tripboards.onboardingnotcompleted';
export const ONBOARDED_KEY = 'tripboards.onboardingcompleted';

const writeStarted = () => {
    writeToStorage(STARTED_KEY, 'true');
    writeToStorage(COMPLETED_KEY, 'true');
};

const writeCompleted = () => {
    writeToStorage(STARTED_KEY, 'true');
    writeToStorage(COMPLETED_KEY, 'false');
    writeToStorage(ONBOARDED_KEY, 'true');
};

const writeOnboarded = () => {
    writeToStorage(ONBOARDED_KEY, 'true');
};

const reset = () => {
    writeToStorage(STARTED_KEY, 'false');
    writeToStorage(COMPLETED_KEY, 'false');
    writeToStorage(ONBOARDED_KEY, 'false');
};

export function registerAllMiddleware() {
    registerMiddleware(actions.STARTED_TRIPBOARD_CREATION, writeStarted);
    registerMiddleware(actions.COMPLETED_TRIPBOARD_CREATION, writeCompleted);
    registerMiddleware(actions.COMPLETED_TRIPBOARD_ONBOARDING, writeOnboarded);
    registerMiddleware(actions.RESET_ONBOARDING_FLAGS, reset);
}

export default registerAllMiddleware;



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/middleware.js